import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m17 17-5 5V12l-5 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14.5 9.5 17 7l-5-5v4.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BluetoothOff";
const BluetoothOff = memo(themed(Icon));
export {
  BluetoothOff
};
//# sourceMappingURL=bluetooth-off.js.map
